import React from 'react';
import {LanguageContext} from './localization';
import {Link} from 'react-router-dom';

export default class RouteErrorBoundary extends React.Component {
 static contextType=LanguageContext;
 state={error:null};
 static getDerivedStateFromError(error){return {error};}
 render(){const tr=this.context.t;
  if(this.state.error)return <main id="main-content" className="account-container" role="alert">
   <h1>{tr('This page couldn’t load.')}</h1>
   <p>{tr('Please reload the page to try again. If you are offline, reconnect first.')}</p>
   <button className="button" onClick={()=>window.location.reload()}>{tr('Reload page')}</button>
   <Link className="text-link" style={{marginLeft:20}} to="/">{tr('Back to home')}</Link>
  </main>;
  return this.props.children;
 }
}
